// extracted by mini-css-extract-plugin
export default {"column":"OjfmsgSjlMfu4UVKMzY5","header":"RV8YiwwZdMQo6S4hIj2K"};